import Path from "@core/FileProvider/Path/Path";
import { useArticlePropsStore } from "@core-ui/stores/ArticlePropsStore/ArticlePropsStore.provider";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { useMemo } from "react";

export const useAgentOpenCatalogPaths = (): { openCatalogName: string | null; openItemPath: string | null } => {
	const articlePath = useArticlePropsStore((s) => s.data.ref.path);
	const catalogName = useCatalogPropsStore((s) => s.data?.name);
	const catalogPath = useCatalogPropsStore((s) => s.data?.basePath);
	return useMemo(() => {
		const itemPath = catalogPath ? new Path(catalogPath).subDirectory(new Path(articlePath)) : null;
		if (!itemPath) return { openCatalogName: null, openItemPath: null };
		return { openCatalogName: catalogName, openItemPath: itemPath.value || null };
	}, [articlePath, catalogName, catalogPath]);
};
